import { dcpcApi } from './dcpcApi';

const TAG = 'Files';

dcpcApi.enhanceEndpoints({ addTagTypes: [TAG] });

const eventsApi = dcpcApi.injectEndpoints({
  endpoints: (builder) => ({

    getFiles: builder.query({
      query: (url) => ({
        url,
      }),
      transformResponse: (response) => ({
        defaultData: response,
        mappedData: response.reverse(),
      }),
      providesTags: [TAG],
    }),

    sendFile: builder.mutation({
      query: ({ url, body }) => ({
        url,
        method: 'POST',
        body,
      }),
      invalidatesTags: [TAG],
    }),

    deleteFile: builder.mutation({
      query: (url) => ({
        url,
        method: 'DELETE',
      }),
      invalidatesTags: [TAG],
    }),

  }),
});

export const {
  useGetFilesQuery,
  useSendFileMutation,
  useDeleteFileMutation,
} = eventsApi;

export const filesUrls = {
  user: {
    getFiles: 'userfiles/',
    downloadFile: (id) => `${process.env.REACT_APP_API_PREFIX}/userfiles/uploadfile/${id}`,
  },
  device: (deviceId) => ({
    description: 'Файлы датчиков',
    getFiles: `datasource-program-blocks/${deviceId}/additional-info/`,
    sendFile: `datasource-program-blocks/${deviceId}/additional-info/`,
    deleteFile: (fileId) => `datasource-program-blocks/${deviceId}/additional-info/${fileId}`,
    downloadFile: (fileId) => `http://localhost:8888${process.env.REACT_APP_API_PREFIX}datasource-program-blocks/${deviceId}/additional-info/${fileId}/file`,
  }),
  datasource: (datasourceId) => ({
    description: 'Файлы источника',
    getFiles: `datasources/${datasourceId}/additional_info/`,
    sendFile: `datasources/${datasourceId}/additional_info/`,
    deleteFile: (fileId) => `datasources/${datasourceId}/additional_info/${fileId}`,
    downloadFile: (fileId) => `${process.env.REACT_APP_API_PREFIX}/datasources/${datasourceId}/additional_info/${fileId}/file`,
  }),
  station: (stationId) => ({
    description: 'Файлы станции',
    getFiles: `station/${stationId}/additional_info/`,
    sendFile: `station/${stationId}/additional_info/`,
    deleteFile: (fileId) => `station/${stationId}/additional_info/${fileId}`,
    downloadFile: (fileId) => `${process.env.REACT_APP_API_PREFIX}/station/${stationId}/additional_info/${fileId}/file`,
  }),

};
